(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('astreinte', {
            parent: 'technicienMenu',
            url: '/astreinte?page&sort&search&technicien&year&month',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.astreinte.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/astreinte/astreintes.html',
                    controller: 'AstreinteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                technicien: null,
                year:null,
                month:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        technicien: $stateParams.technicien,
                        year: $stateParams.year,
                        month: $stateParams.month,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('astreinte');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('astreinte-detail', {
            parent: 'astreinte',
            url: '/astreinte/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.astreinte.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/astreinte/astreinte-detail.html',
                    controller: 'AstreinteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('astreinte');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Astreinte', function($stateParams, Astreinte) {
                    return Astreinte.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'astreinte',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('astreinte-detail.edit', {
            parent: 'astreinte-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-dialog.html',
                    controller: 'AstreinteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Astreinte', function(Astreinte) {
                            return Astreinte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte.new', {
            parent: 'astreinte',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-dialog.html',
                    controller: 'AstreinteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                date: null,
                                hours: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astreinte', null, { reload: 'astreinte' });
                }, function() {
                    $state.go('astreinte');
                });
            }]
        })
        .state('astreinte.edit', {
            parent: 'astreinte',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-dialog.html',
                    controller: 'AstreinteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Astreinte', function(Astreinte) {
                            return Astreinte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astreinte', null, { reload: 'astreinte' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte.delete', {
            parent: 'astreinte',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-delete-dialog.html',
                    controller: 'AstreinteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Astreinte', function(Astreinte) {
                            return Astreinte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astreinte', null, { reload: 'astreinte' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
